import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HubCardStack } from "../../components";

export const StyledCard = styled(HubCardStack, {
  shouldForwardProp: (prop) => !["minHeight"].includes(prop),
})(({ minHeight = "400px" }) => ({
  flex: 1,
  minHeight,
  maxHeight: minHeight,
  overflow: "hidden",
  gap: "15px",
}));

export const StyledCardGrid = styled(Stack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gridTemplateRows: "400px",
  gap: "15px",
  alignItems: "center",
}));

export const StyledTitleStack = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: "25px",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px",
  borderBottom: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  backgroundColor: theme.palette.hubColors.white,
  "& .MuiOutlinedInput-root": {
    padding: "5px 10px",
    borderRadius: 6,
    svg: { width: 12, height: 12 },
  },
}));

export const StyledLineStack = styled(Stack, {
  shouldForwardProp: (prop) => !["color"].includes(prop),
})(({ theme, color }) => ({
  gap: "8px",
  height: "100%",
  "& .MuiChartsLegend-root": {
    display: "none",
  },
  "& .MuiHighlightElement-root": {
    fill: color || theme.palette.hubColors.mainFocus,
  },
  ".MuiLineElement-root": {
    stroke: color || theme.palette.hubColors.mainFocus,
    strokeWidth: 1.5,
  },
  ".MuiMarkElement-root": {
    stroke: color || theme.palette.hubColors.mainFocus,
    fill: color || theme.palette.hubColors.mainFocus,
    scale: "0.7",
    strokeWidth: 2,
  },
  ".MuiAreaElement-root": {
    fill: `url(#LinearGradient-${color})`,
  },
}));

export const StyledMultiLineStack = styled(Stack)(({ theme }) => ({
  gap: "8px",
  height: "100%",
  "& .MuiChartsLegend-root": {
    display: "none",
  },
  ".MuiLineElement-root": {
    strokeWidth: 1.5,
  },
  ".MuiMarkElement-root": {
    scale: "0.7",
    strokeWidth: 2,
  },
}));
